/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import { useState, useEffect } from "react";

import { AxiosGet, AxiosPost } from 'service/CommonFunction/TS_function';
//ComponentsMUI
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Typography from '@mui/material/Typography';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { StepIconProps } from '@mui/material/StepIcon';

//ICON
import { FaFlagCheckered, FaHourglassHalf } from "react-icons/fa";
import { BsFillCheckCircleFill } from "react-icons/bs";
import { HiMail, HiMailOpen } from "react-icons/hi";
import { BiEdit } from "react-icons/bi";
import { ImHammer2 } from "react-icons/im";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Tooltip } from '@mui/material';
import Accordion from 'components/Common/Accordion/Accordion';
import moment from 'moment';
import AccordionCustom from 'components/Common/Accordion/AccordionCustom';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';

const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#31A54B',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {      //อนุมัติเสร้จแล้ว
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#31A54B',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#eaeaf0'
    },
    [`&.${stepConnectorClasses.active}.${stepConnectorClasses.disabled}`]: {     //ระหว่างรออนุมัติ
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#F4B400',
        },
    },
    [`&.${stepConnectorClasses.active}.${stepConnectorClasses.disabled} ~ .${stepConnectorClasses.active}.${stepConnectorClasses.disabled} `]: {     //ระหว่างรออนุมัติ
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#bdbdbd',
        },
    },
    [`&.${stepConnectorClasses.active}.${stepConnectorClasses.disabled}.root-disabled`]: {     //ระหว่างรออนุมัติ
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#bdbdbd',
        },
    },
}));

const QontoStepIconRoot = styled('div')<{ ownerState: { active?: boolean } }>(
    ({ theme, ownerState }) => ({
        color: '#eaeaf0',
        display: 'flex',
        height: 22,
        alignItems: 'center',
        justifyContent: "center",
        fontSize: "1.5rem",
        // marginTop:'-38px',
        marginTop: 0,
        ...(ownerState.active && {
            color: '#F4B400',
            zIndex: 5,
        }),
        '& .QontoStepIcon-completedIcon': {
            color: '#31A54B',
            backgroundColor: "#31A54B",
            zIndex: 5,
            // fontSize: 18,
        },
        '& .QontoStepIcon-WaitIcon': {
            color: '#E5E5E5',
            backgroundColor: "#E5E5E5",
            zIndex: 5,
        },
        '& .QontoStepIcon-WaitIcon-step-next': {
            color: '#F4B400',
            backgroundColor: "#F4B400",
            zIndex: 5,
        },
        '& .MuiSvgIcon-root': {
            fontSize: "1.5rem"
        },
        '& .QontoStepIcon-rejectedIcon': {
            color: '#F3342F',
            backgroundColor: "#F3342F",
            zIndex: 5,
        },
    }),
);

QontoStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
    /**
     * สี Process = {"W" = เหลือง , "P" = เขียว , "R" = แดง}
     */
    cProcess: PropTypes.string,
};
var nLastUpdate = null
var arrLength = 0
function QontoStepIcon(props) {
    var { active, completed, className, icon } = props;

    var classIcon = "QontoStepIcon-WaitIcon";
    let IconSplit = icon ? icon.split("_") : [];
    let sStatusIcon = IconSplit.length > 0 ? IconSplit[0] : "";
    let sStepId = IconSplit.length > 0 ? IconSplit[1] : 0;

    if (arrLength === nLastUpdate && completed) {
        completed = true
    } else {
        if (className != null && className.includes("next-step")) {
            classIcon = "QontoStepIcon-WaitIcon-step-next"
        }
    }

    switch (sStatusIcon) {
        case 'R':
            classIcon = "QontoStepIcon-rejectedIcon"
            break;
        case 'P':
            classIcon = "QontoStepIcon-completedIcon"
            break;
    }

    return (
        <QontoStepIconRoot ownerState={{ active }} className={className}>
            {
                sStepId == 1
                    ?
                    <>
                        <div
                            style={{ height: '25px', width: '25px', borderRadius: '30px', position: 'relative' }}
                            className={completed ? "QontoStepIcon-completedIcon" : classIcon}
                        >
                            <HiMail
                                fontSize='small'
                                style={{
                                    color: '#ffffff',
                                    position: 'absolute',
                                    top: '15%',
                                    left: '15%',
                                    fontSize: '18px',
                                }}
                            />
                        </div>
                    </>
                    : sStepId == 2
                        ?
                        <>
                            <div
                                style={{ height: '25px', width: '25px', borderRadius: '30px', position: 'relative' }}
                                className={completed ? "QontoStepIcon-completedIcon" : classIcon}
                            >
                                <HiMailOpen
                                    fontSize='small'
                                    style={{
                                        color: '#ffffff',
                                        position: 'absolute',
                                        top: '15%',
                                        left: '15%',
                                        fontSize: '18px',
                                    }}
                                />
                            </div>
                        </>
                        : sStepId == 3
                            ?
                            <>
                                <div
                                    style={{ height: '25px', width: '25px', borderRadius: '30px', position: 'relative' }}
                                    className={completed ? "QontoStepIcon-completedIcon" : classIcon}
                                >
                                    <BiEdit
                                        fontSize='small'
                                        style={{
                                            color: '#ffffff',
                                            position: 'absolute',
                                            top: '15%',
                                            left: '15%',
                                            fontSize: '18px',
                                        }}
                                    />
                                </div>
                            </>
                            : sStepId == 4
                                ?
                                <>
                                    <div
                                        style={{ height: '25px', width: '25px', borderRadius: '30px', position: 'relative' }}
                                        className={completed ? "QontoStepIcon-completedIcon" : classIcon}
                                    >
                                        <FaHourglassHalf
                                            fontSize='small'
                                            style={{
                                                color: '#ffffff',
                                                position: 'absolute',
                                                top: '15%',
                                                left: '15%',
                                                fontSize: '18px',
                                            }}
                                        />
                                    </div>
                                </>
                                : sStepId == 5
                                    ?
                                    <>
                                        <div
                                            style={{ height: '25px', width: '25px', borderRadius: '30px', position: 'relative' }}
                                            className={completed ? "QontoStepIcon-completedIcon" : classIcon}
                                        >
                                            <ImHammer2
                                                fontSize='small'
                                                style={{
                                                    color: '#ffffff',
                                                    position: 'absolute',
                                                    top: '15%',
                                                    left: '15%',
                                                    fontSize: '18px',
                                                }}
                                            />
                                        </div>
                                    </>
                                    : sStepId == 6
                                        ?
                                        <>
                                            <div
                                                style={{ height: '25px', width: '25px', borderRadius: '30px', position: 'relative' }}
                                                className={completed ? "QontoStepIcon-completedIcon" : classIcon}
                                            >
                                                <BsFillCheckCircleFill
                                                    fontSize='small'
                                                    style={{
                                                        color: '#ffffff',
                                                        position: 'absolute',
                                                        top: '15%',
                                                        left: '15%',
                                                        fontSize: '18px',
                                                    }}
                                                />
                                            </div>
                                        </>
                                        : sStepId == 7
                                            ?
                                            <>
                                                <div
                                                    style={{ height: '25px', width: '25px', borderRadius: '30px', position: 'relative' }}
                                                    className={completed ? "QontoStepIcon-completedIcon" : classIcon}
                                                >
                                                    <FaFlagCheckered
                                                        fontSize='small'
                                                        style={{
                                                            color: '#ffffff',
                                                            position: 'absolute',
                                                            top: '15%',
                                                            left: '15%',
                                                            fontSize: '18px',
                                                        }}
                                                    />
                                                </div>
                                            </>
                                            : null
            }
        </QontoStepIconRoot>
    );
}

interface VOCID {
    sVOCFormID?: string | null;
    IsDisplay?: boolean | true;
};

const VerticalStepper = (props: VOCID) => {

    const { sVOCFormID, IsDisplay } = props;

    const [IsShowStepper, SetIsShowStepper] = useState(false);
    const [ArrSteps, SetArrSteps] = useState<any>([]);
    const [ActiveStep, SetActiveStep] = useState(0);
    const [Steps_Present, SetSteps_Present] = useState<any>();

    useEffect(() => {
        if (sVOCFormID != null) {
            GetStepperWorkFlow(sVOCFormID);
        }
    }, [sVOCFormID])

    const GetStepperWorkFlow = (sVOCFormID) => {
        let data = {
            "sVOCFormID": sVOCFormID,
            "sLanguage": currentLanguage(),
        }
        AxiosGet("VOC/GetStepperWorkFlow", data, (res) => {
            nLastUpdate = res.ActiveStep
            arrLength = res.lstSteps.length
            SetArrSteps(res.lstSteps);
            SetActiveStep(res.ActiveStep);
            SetSteps_Present(res.lstSteps_Present);
        });
    }

    return (
        <Box >
            <AccordionCustom
                header={currentLanguage() == "th" ? "สถานะดำเนินการ" : "Status"}
                onExpanded={true}
                onClink={() => { SetIsShowStepper(!IsShowStepper) }}
                SubHeader={
                    <>
                        {(IsShowStepper === false && Steps_Present?.sStatus != null) &&
                            <Step key={1}>
                                <StepLabel
                                    StepIconComponent={QontoStepIcon}
                                    className="align-start"
                                    StepIconProps={{
                                        className: "next-step",
                                        completed: Steps_Present?.cProcess == "P" ? true : false,
                                        icon: (Steps_Present.cProcess ?? "N") + "_" + (Steps_Present.nStepID ?? 0),
                                    }}
                                >
                                    <Typography style={{ fontSize: '12px', fontWeight: 'bold' }}>{Steps_Present?.sStatus}</Typography>
                                    <Box style={{ border: '1px solid #d4d4d4', borderRadius: '4px', padding: '5px', minHeight: '54px' }}>
                                        <Typography style={{ fontSize: '12px' }}>{Steps_Present?.sAction}</Typography>
                                        <Typography style={{ fontSize: '12px' }}>
                                            {
                                                Steps_Present?.sDate != null && Steps_Present?.sDate != "" ?
                                                    (currentLanguage() == "th" ?
                                                        moment(Steps_Present?.sDate).add(543, 'year').format("DD/MM/YYYY HH:mm น.")
                                                        : moment(Steps_Present?.sDate).format("DD/MM/YYYY HH:mm"))
                                                    : null
                                            }
                                        </Typography>
                                    </Box>
                                </StepLabel>
                            </Step>
                        }
                    </>
                }
            >
                <Stepper
                    orientation="vertical"
                    activeStep={ActiveStep}
                    connector={<QontoConnector className={Steps_Present?.nLevel !== (ActiveStep + 1) ? "root-disabled" : "stepper-connect"} />}
                >
                    {(ArrSteps || []).map((label, index) => (
                        <Step key={label.sStatus + index} active={true}>
                            <StepLabel
                                StepIconComponent={QontoStepIcon}
                                StepIconProps={{
                                    className: Steps_Present?.nLevel + 1 === (label.nLevel) ? "next-step" : null,
                                    completed: label.cProcess == "P" ? true : false,
                                    icon: (label.cProcess ?? "N") + "_" + (label.nStepID ?? 0),
                                }}
                            >
                                <Typography style={{ fontSize: '12px', fontWeight: 'bold' }}>{label.sStatus}</Typography>
                            </StepLabel>
                            <StepContent
                                className={`${label.nOrder <= (ActiveStep + 1) && label.cProcess != "R" ? ((label.cProcess == "W" || label.cProcess == null) && ArrSteps[index + 1]?.cProcess == 'P' ? "step-P" : `step-${label.cProcess}`) : ""}`}
                            >
                                <Box style={{ border: '1px solid #d4d4d4', borderRadius: '4px', padding: '8px', minHeight: '54px' }}>
                                    <Typography style={{ fontSize: '12px' }}>{label?.sAction}</Typography>
                                    <Typography style={{ fontSize: '12px' }}>
                                        {label?.sDate != null && label?.sDate != "" ?
                                            (currentLanguage() == "th" ?
                                                moment(label?.sDate).add(543, 'year').format("DD/MM/YYYY HH:mm น.")
                                                : moment(label?.sDate).format("DD/MM/YYYY HH:mm"))
                                            : null
                                        }
                                    </Typography>

                                </Box>
                            </StepContent>
                        </Step>
                    ))}
                </Stepper>
            </AccordionCustom >
        </Box >
    )
}

export default VerticalStepper
